<template>
  <v-dialog v-model="showdialog" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-card-text
        >Please stand by - You are being authorised
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const {
  mapGetters: mapAuthGetters,
  mapActions: mapAuthActions
} = createNamespacedHelpers(`auth`);

export default {
  name: "callback",
  data() {
    return {
      showdialog: true
    };
  },
  methods: {
    ...mapAuthActions(["handleAuthentication"])
  },
  computed: {
    ...mapAuthGetters(["isAuthenticated", "status"])
  },
  mounted() {
    const vm = this;
    vm.handleAuthentication()
      .then(result => {
        vm.showdialog = false;
        if (result) vm.$router.push("/list-commissions");
      })
      .catch(() => {
        vm.$router.push("/list-commissions");
      });
  }
};
</script>

<style>
.spinner {
  position: absolute;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
